// generated by the plop

import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { append, patch } from '@ngxs/store/operators';

import { PROGRESS_STATUSES } from 'symbols';
import { ClientService } from '../../services/client.service';
import {
  ClearScrollPositionClientList,
  GetClientList,
  GetClientListError,
  GetClientListSuccess, SetLastOpenedClientId, UpdateScrollPositionClientList
} from './client-list.actions';
import { CLIENT_LIST_STATE_DEFAULT, ClientListStateModel } from './client-list.model';

@State({ name: 'ClientList', defaults: CLIENT_LIST_STATE_DEFAULT })
@Injectable()
export class ClientListState {

  constructor(private clientService: ClientService) {
  }

  @Selector()
  static loadClientListStatus(state: ClientListStateModel): ClientListStateModel['loadClientListStatus'] {
    return state.loadClientListStatus;
  }

  @Selector()
  static clientList(state: ClientListStateModel): ClientListStateModel['clientList'] {
    return state.clientList;
  }


  @Selector()
  static lastOpenedDocId(state: ClientListStateModel): ClientListStateModel['lastOpenedDocId'] {
    return state.lastOpenedDocId;
  }

  @Selector()
  static scrollPosition(state: ClientListStateModel): ClientListStateModel['scrollPosition'] {
    return state.scrollPosition;
  }


  @Action(GetClientList)
  getClientList(ctx: StateContext<ClientListStateModel>, { filter, lazy }: GetClientList): void {
    if (lazy) {
      const next = ctx.getState().clientList?.links?.next;
      if (next) {
        ctx.patchState({
          loadClientListStatus: PROGRESS_STATUSES.IN_PROGRESS
        });
        this.clientService.getClientListLazy(next).subscribe({
          next: res => ctx.dispatch(new GetClientListSuccess(res, lazy)),
          error: error => ctx.dispatch(new GetClientListError(error))
        });
      }
    } else {
      ctx.patchState({
        loadClientListStatus: PROGRESS_STATUSES.IN_PROGRESS
      });
      this.clientService.getClientListPaginate(filter).subscribe({
        next: res => ctx.dispatch(new GetClientListSuccess(res, lazy)),
        error: error => ctx.dispatch(new GetClientListError(error))
      });
    }
  }

  @Action(GetClientListSuccess)
  getClientListSuccess(ctx: StateContext<ClientListStateModel>, {
    clientList,
    lazy
  }: GetClientListSuccess): void {
    ctx.patchState({
      loadClientListStatus: PROGRESS_STATUSES.SUCCESS
    });
    if (lazy) {
      ctx.setState(patch({
        clientList: patch({
          data: append([...clientList.data]),
          links: clientList.links,
          meta: clientList.meta
        })
      }));
    } else {
      ctx.patchState({
        clientList
      });

    }
  }

  @Action(GetClientListError)
  getClientListError(ctx: StateContext<ClientListStateModel>, { error }: GetClientListError): void {
    ctx.patchState({
      loadClientListStatus: PROGRESS_STATUSES.FAIL
    });
  }


  @Action(ClearScrollPositionClientList)
  clearScrollPositionClientList(ctx: StateContext<ClientListStateModel>): void {
    ctx.patchState({ scrollPosition: 0 });
  }

  @Action(UpdateScrollPositionClientList)
  updateScrollPosition(ctx: StateContext<ClientListStateModel>, { position }: UpdateScrollPositionClientList): void {
    ctx.patchState({ scrollPosition: position });
  }

  @Action(SetLastOpenedClientId)
  setLastOpenedDocId(ctx: StateContext<ClientListStateModel>, { contractId }: SetLastOpenedClientId): void {
    ctx.patchState({ lastOpenedDocId: contractId });
  }



  // @Action(UpdatedClientByWS)
  // updatedOrderBuWS(ctx: StateContext<ClientListStateModel>, { contract }: UpdatedClientByWS): void {
  //
  //   ctx.setState(patch({
  //     contractList: patch({
  //       data: updateItem(o => o?.id === contract.id, contract)
  //     })
  //   }));
  // }
  //
  // @Action(CreatedClientByWS)
  // createdOrderByWS(ctx: StateContext<ClientListStateModel>, { contract }: CreatedClientByWS): void {
  //   ctx.setState(patch({
  //     contractList: patch({
  //       data: insertItem(contract, 0),
  //       meta: patch({
  //         totalItems: ctx.getState().contractList?.meta?.totalItems + 1
  //       })
  //     })
  //   }));
  // }
}


